import { IBundleErrorState } from "./bundle-error-state.interface";
const bundleErrorState: IBundleErrorState = { failureCallback: () => {} };

export const bundleErrorStateManager = {
  /**
   * This is called whenever items view sees an error of bundle failure
   *
   * @param bundlepath The url of the bundle that failed to download
   * and triggered this callback
   */
  triggerBundleErrorCallback: (bundlePath: string) => {
    if (bundleErrorState.failureCallback) {
      bundleErrorState.failureCallback(bundlePath);
    }
  },
  /**
   * Registeres a callback and to be called on bundle failure
   *
   * @param value The is the callback which has to be registered.
   * Can also be ovveridden with null
   */
  setBundleErrorCallback: (value: ((bundlePath: string) => void) | null) => {
    bundleErrorState.failureCallback = value;
  }
};
